import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { AboutSteto } from "@/pages/account/AboutSteto.tsx";
import { AbsenceMessageCard } from "@/pages/account/AbsenceMessage/AbsenceMessageCard.tsx";
import { GeneralInformation } from "@/pages/account/GeneralInformation.tsx";
import { Language } from "@/pages/account/Language.tsx";
import { MailPreference } from "@/pages/account/preferences/MailPreference.tsx";
import { Security } from "@/pages/account/Security.tsx";
import { Terms } from "@/pages/account/Terms.tsx";
import { UserHelp } from "@/pages/account/UserHelp.tsx";
import { Theme } from "@/theme/CreateTheme.ts";
import { Page } from "@/uiKit/atoms/page/Page.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";
import { PageHeader } from "@/uiKit/atoms/page/PageHeader.tsx";

import { AnteriorityCard } from "./AnterioritySearchCard";

export const PractitionerAccountPage: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);
  return (
    <Page id="practitioner-account-page">
      <PageHeader title={t("pages.account.title")} />
      <PageContent className={styles.content}>
        <GeneralInformation />
        <MailPreference />
        <AbsenceMessageCard />
        <div className={styles.row}>
          <Language className={styles.rowItem} />
          <Security className={styles.rowItem} />
          <AnteriorityCard className={styles.rowItem} />
        </div>
        <UserHelp isPractitioner />
        <Terms />
        <AboutSteto />
      </PageContent>
    </Page>
  );
};

const makeStyles = (theme: Theme) => ({
  content: css({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(12),
  }),
  row: css({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(12),
  }),
  rowItem: css({
    flex: 1,
  }),
});
